import req from '@/util/request'

export function loginApi(data) {
  return req.post('/api/user/login', data)
}

export function getTotpQrcode(data) {
  return req.post('/api/totp/qrcode', data)
}

export function confirmTotp(data) {
  return req.post('/api/totp/confirm', data)
}

export function getCaptcha(captchaId = '') {
  const data = {}
  if (captchaId !== '') data['captcha_id'] = captchaId
  return req.post('/api/captcha/index', data)
}

export function sendEmailVerify(data) {
  return req.post('/api/captcha/sendEmailVerify', data)
}

export function registerApi(data) {
  return req.post('/api/user/register', data)
}

export function passwordUpdate(data) {
  return req.post('/api/password/update', data)
}

export function passwordForget(data) {
  return req.post('/api/login/forgot', data)
}

export function marketList(data) {
  // const data = {}
  // if (contract !== '') data['contract'] = contract
  // if (secondContract !== '') data['second_contract'] = secondContract
  return req.post('/api/market/list', data)
}

export function exchangeRobot(data) {
  return req.post('/api/exchange/robot', data)
}

export function getUserAsset(data) {
  return req.post('/api/user/asset', data)
}

export function exchangeTrade(type, data) {
  return req.post(`/api/trade/${type}`, data)
}

export function orderList(type,data) {
  return req.post(`/api/trade/order/${type}`, data)
}

export function exchangeCancel(type, data) {
  return req.post(`/api/exchange/cancel/${type}`, data)
}

export function contractList(data) {
  return req.post('/api/exchange/contractList', data)
}

export function closeContract(data) {
  return req.post('/api/exchange/closeContract', data)
}

export function closeContractAll(data) {
  return req.post('/api/exchange/closeContractAll', data)
}

export function assetRate(data) {
  return req.post('/api/exchange/holdAssetRate', data)
}

export function setSlTp(data) {
  return req.post('/api/future/set', data)
}

export function getUserInfo(data) {
  return req.post('/api/auth/info', data)
}

export function updateEmail(data) {
  return req.post('/api/account/email', data)
}

export function auth(data) {
  return req.post('/api/user/auth', data)
}

export function exchangeCoin(data) {
  return req.post('/api/exchange/coin', data)
}

export function coinContract(data) {
  return req.post('/api/exchange/coinContract', data)
}

export function rechargeList(data) {
  return req.post('/api/recharge/list', data)
}

export function withdraw(data) {
  return req.post('/api/withdraw/apply', data)
}

export function withdrawList(data) {
  return req.post('/api/withdraw/list', data)
}

export function transfer(data) {
  return req.post('/api/transfer', data)
}

export function balanceHistory(data) {
  return req.post('/api/fund/record', data)
}

export function getArticle(data) { // type: 0 轮播图 1 公告 
  return req.post('/api/common/article', data)
}

export function getRechargeCode(data) {
  return req.post('/api/account/wallet', data)
}

export function ieoTrade(data) {
  return req.post('/api/ieo/exchange', data)
}

export function ieoOrder(data) {
  return req.post('/api/ieo/order/list', data)
}

export function getConfig(data) {
  return req.post('/api/common/config', data)
}

export function withdrawCancel(data) {
  return req.post('/api/withdraw/cancel', data)
}

export function pledgeLock(data) {
  return req.post('/api/ieo/pledgeLock', data)
}

export function ieoSell(data) {
  return req.post('/api/ieo/ieoSell', data)
}

export function pledgeList(data) {
  return req.post('/api/ieo/pledgeList', data)
}

export function pledgeBorrowApply(data) {
  return req.post('/api/pledgeBorrow/apply', data)
}

export function pledgeBorrowList(data) {
  return req.post('/api/pledgeBorrow/list', data)
}

export function pledgeBorrowRepay(data) {
  return req.post('/api/pledgeBorrow/repay', data)
}

export function ieoSellList(data) {
  return req.post('/api/ieo/ieoSellList', data)
}

export function ieoStat(data) {
  return req.post('/api/ieo/stat', data)
}

export function accountStat(data) {
  return req.post('/api/account/stat', data)
}

/////////////////////////////////////////////////////

export function registerSend(data) {
  return req.post('/api/register/send', data)
}

export function passwordSend(data) {
  return req.post('/api/password/send', data)
}

export function announceHome(data) {
  return req.post('/api/announce/home', data)
}

export function announceList(data) {
  return req.post('/api/announce/list', data)
}

export function announceDetail(data) {
  return req.post('/api/announce/detail', data)
}

export function fundpwdUpdate(data) {
  return req.post('/api/fund_pwd/update', data)
}

export function authInfo(data) {
  return req.post('/api/auth/info', data)
}

export function futureOpen(data) {
  return req.post('/api/future/open', data)
}

export function futureOrder(type, data) {
  return req.post(`/api/future/${type}`, data)
}


export function tradeCancel(data) {
  return req.post('/api/trade/cancel', data)
}

export function futureClose(data) {
  return req.post('/api/future/close', data)
}

export function futureCancel(data) {
  return req.post('/api/future/cancel', data)
}


export function marketIeo(data) {
  return req.post('/api/market/ieo', data)
}

export function ieoExchange(data) {
  return req.post('/api/ieo/exchange', data)
}

export function ieoOrderList(data) {
  return req.post('/api/ieo/order/list', data)
}

export function ieoOrderCancel(data) {
  return req.post('/api/ieo/order/cancel', data)
}

export function userInfo(data) {
  return req.post('/api/user/info', data)
}

export function marketInfoRecharge(data) {
  return req.post('/api/market/info/recharge', data)
}

export function rechargeUrl(data) {
  return req.post('/api/recharge/url', data)
}

export function marketInfoWithdraw(data) {
  return req.post('/api/market/info/withdraw', data)
}

export function transferHistory(data) {
  return req.post('/api/transfer/history', data)
}

export function ieoOrderStat(data) {
  return req.post('/api/ieo/order/stat', data)
}

export function futureCloseAll(data) {
  return req.post('/api/future/close/all', data)
}

export function futureChild(data) {
  return req.post('/api/future/child', data)
}

export function withdrawCheck(data) {
  return req.post('/api/withdraw/check', data)
}

export function withdrawSend(data) {
  return req.post('/api/withdraw/send', data)
}

export function oldEmailSend(data) {
  return req.post('/api/oldEmail/send', data)
}

export function newEmailSend(data) {
  return req.post('/api/newEmail/send', data)
}

export function emailChange(data) {
  return req.post('/api/email/change', data)
}

export function marketFavoriteList(data) {
  return req.post('/api/market/favorite/list', data)
}

export function marketFavoriteSave(data) {
  return req.post('/api/market/favorite/save', data)
}
